<script lang="ts" setup>
import {
  ContextMenu,
  ContextMenuCheckboxItem,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuLabel,
  ContextMenuRadioGroup,
  ContextMenuRadioItem,
  ContextMenuSeparator,
  ContextMenuShortcut,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
  ContextMenuTrigger,
} from "@/components/ui/context-menu";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["edit", "delete"]);

const isOpen = ref(false);

const editAnnotation = () => {
  // isOpen.value = false;
  emit("edit");
};

const deleteAnnotation = () => {
  isOpen.value = false;
  emit("delete");
};
</script>

<template>
  <ContextMenu v-model:open="isOpen">
    <ContextMenuTrigger>
      <slot />
    </ContextMenuTrigger>
    <ContextMenuContent>
      <ContextMenuItem @click="editAnnotation">
        <div
          class="flex flex-row items-center w-full justify-start text-primary"
        >
          <BaseIconEdit class="mr-1" />
          Edit
        </div>
      </ContextMenuItem>

      <ContextMenuItem @click="deleteAnnotation">
        <div
          class="flex flex-row items-center w-full justify-start text-danger"
        >
          <BaseIconDelete class="mr-1" />
          Delete
        </div>
      </ContextMenuItem>
    </ContextMenuContent>
  </ContextMenu>
</template>

<style scoped></style>
